module.exports = __webpack_public_path__ + "img/espanta.d148b3ce.svg";